import { useCurrentStateAndParams } from '@uirouter/react';
import { useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { pageStateAtom } from '../vendor_list_atoms';
import { pageStateVM } from '../../../../core/page/page_view_models';

export const useVendorListInit = (): void => {
    const route = useCurrentStateAndParams();
    const setState = useSetImmerAtom(pageStateAtom);

    // INIT
    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                // get context from Angular
                // const ctx = ngContext();
                draft.canEdit = true; // revisit this...
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
        };
    }, [route, setState]);
};
